/* eslint-disable camelcase */
import { useTranslation } from '../../lib/i18n'

export default function StampAwardedNotification({ notification }) {
  const { t } = useTranslation()
  const { creator_name, stampable_type, stamp_name } = notification?.notifiable

  return (
    <>
      <p className="w-full max-w-200 md:max-w-300 line-clamp-2 overflow-hidden text-off-black font-bold">
        {t('common.youGotAnImpactStamp')}
      </p>
      <p className="w-full max-w-200 md:max-w-300 line-clamp-2 overflow-hidden">
        {creator_name}{' '}
        {t('common.hasAwardedYourWithAStamp', {
          type: stampable_type,
          stamp: stamp_name,
        })}
      </p>
    </>
  )
}
